import React from 'react';
import { SliderInput } from 'comp/input';
import styles from './axis-styles.scss';
import { COLUMN_DIVISOR } from 'ub/elements/form/geometry';

export default function FormLayoutControls({
  onSlideChange,
  onBeforeSlideChange,
  onAfterSlideChange,
  fieldWidth,
}) {
  return (
    <div className={styles.container}>
      <SliderInput
        label="Columns"
        min={1}
        max={window.editor && window.editor.page ?
          window.editor.page.getConfigValue('maxFormColumns') : 4}
        step={1}
        value={COLUMN_DIVISOR / fieldWidth}
        onChange={onSlideChange}
        onBeforeChange={onBeforeSlideChange}
        onAfterChange={onAfterSlideChange}
        readonlyInput
      />
    </div>
  );
}

FormLayoutControls.propTypes = {
  onSlideChange: React.PropTypes.func,
  onBeforeSlideChange: React.PropTypes.func,
  onAfterSlideChange: React.PropTypes.func,
  fieldWidth: React.PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/ui/properties-panel/forms/form-layout-controls.jsx